import { HighlightedText, TitleText } from '../styled-components.js'
import { escapeRegExp } from 'lodash'

const HighlightTitle = ({ title, query }) => {
  const highlightText = (title, query) => {
    if (!query || query === '') return title

    const savePattern = escapeRegExp(query)
    const regex = new RegExp(`(${savePattern})`, 'gi')
    const parts = title.split(regex)

    return parts.map((part, index) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <HighlightedText key={index}>{part}</HighlightedText>
      ) : (
        part
      )
    )
  }

  return <TitleText>{highlightText(title, query)}</TitleText>
}

export default HighlightTitle
